import React from "react";

const SvgClose = props => <svg fill="none" viewBox="0 0 14 14" {...props}><defs /><path stroke="#1A1A1A" strokeLinecap="square" d="M13 1L1 13M1 1l12 12" /></svg>;

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAxNCAxNCI+PGRlZnMvPjxwYXRoIHN0cm9rZT0iIzFBMUExQSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgZD0iTTEzIDFMMSAxM00xIDFsMTIgMTIiLz48L3N2Zz4=";
export { SvgClose as ReactComponent };